<template>
  <el-dialog
    class="modal"
    title="User Info"
    :close-on-click-modal="false"
    :visible="visible"
    @close="$emit('close', false)"
    width="600px">
    <div class="dialog-title" slot="title">
      <i class="iconfont icon-yonghu"></i>
      {{ $t('userInfo') }}
    </div>
    <div class="userinfo-main">
      <div class="edit-section">
        <i class="iconfont iconbianji edit" v-if="!isEdit" @click="isEdit = !isEdit"></i>
        <template v-else>
          <i class="el-icon-check f-s-18" style="margin-right: 6px" @click="updateUser"></i>
          <i class="el-icon-close f-s-18" @click="cancelEdit"></i>
        </template>
      </div>
      <div class="desc-content">
        <div class="info-item">
          <div class="info-item-label">{{ $t('name') }}</div>
          <div class="info-item-content">
            <!-- <el-input v-if="isEdit" type="text" v-model="userCopy.loginName" />
            <template v-else> -->
            {{ userCopy.loginName }}
            <!-- </template> -->
          </div>
        </div>
        <div class="info-item">
          <div class="info-item-label">{{ $t('language') }}</div>
          <div class="info-item-content">
            <!-- <el-select v-if="isEdit" style="width: 100%" :disabled="!isEdit" v-model="userCopy.language" :placeholder="$t('pleaseChoose')"> -->
            <el-select v-if="isEdit" style="width: 100%" :disabled="!isEdit" :value="+userCopy.language" :placeholder="$t('pleaseChoose')" @change="languageChange">
              <el-option
                v-for="item in languageArr"
                class="capitalize"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
            <template v-else>{{ userCopy.language && languageArr.find(n => n.value == userCopy.language).name }}</template>
          </div>
        </div>
        <div class="info-item">
          <div class="info-item-label">{{ $t('emailAddress') }}</div>
          <div class="info-item-content">
            <el-input v-if="isEdit" v-model="userCopy.email" />
            <template v-else>{{ userCopy.email }}</template>
          </div>
        </div>
        <div class="info-item">
          <div class="info-item-label">{{ $t('phone') }}</div>
          <div class="info-item-content">
            <el-input v-if="isEdit" v-model="userCopy.phone" />
            <template v-else>{{ userCopy.phone }}</template>
          </div>
        </div>
      </div>
      <!-- 2021-12-21 -->
      <div class="user-title">{{ $t('limits') }} <span v-if="time != ''" class="span_time">{{$t('msg')}}{{time ? moment(time).format('YYYY-MM-DD') : ''}}</span></div>
      <div>{{ $t('content') }}</div>
      <div class="contentLast">{{ $t('contentLast') }}</div>
      <div style="text-align: center">
        <!-- <el-button class="blue-btn" style="width: 120px;" @click="handleApply">{{ $t('apply') }}</el-button> -->
        <el-switch
          v-model="isApply"
          active-color="#13ce66"
          @change="handleApply"
          >
        </el-switch>
      </div>
      <!--  -->
      <div class="user-title">{{ $t('closeAccount') }}</div>
      <div>{{ $t('closeAccountPermanentlyAll') }}</div>
      <div style="text-align: center">
        <el-button class="blue-btn" style="width: 120px; background-color: red" @click="delAccount">{{ $t('closeAccount') }}</el-button>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      class="modal"
      append-to-body
      title="Prompt"
      :visible.sync="deleteDialog"
      width="30%"
    >
      <div class="dialog-title" slot="title">
        {{ $t('closeAccount') }}
      </div>
      <span>{{ $t('closeAccountPermanently') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="gray-btn" @click="deleteDialog = false">{{ $t('cancel') }}</el-button>
        <el-button class="blue-btn" @click="closeAccout">{{ $t('sure') }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import config from '../../common/config'
import Cookies from 'js-cookie'
import { updateUserInfo, selfDestruct, grantPermission, getUserInfo } from '../../api/user'
import moment from 'moment'

export default {
  name: 'UserInfo',
  props: {
    visible: Boolean,
    data: Object
  },
  data () {
    return {
      isEdit: false,
      deleteDialog: false,
      userCopy: {}, // user的副本数据
      languageArr: this.handleGlobalArr(config.languageArr),
      time: '',
      moment: moment,
      isApply: false
    }
  },
  watch: {
    data () {
      this.copyData()
    }
  },
  mounted () {
    this.copyData()
    this.getTime()
  },
  methods: {
    updateUser () {
      const params = {
        ...this.userCopy
      }
      updateUserInfo(params).then(res => {
        this.isEdit = false
        this.$message.success(this.$t('updateSuccess'))
        this.$emit('success')
      })
    },
    cancelEdit () {
      this.isEdit = false
      this.copyData()
    },
    copyData () {
      this.userCopy = JSON.parse(JSON.stringify(this.data))
    },
    delAccount () {
      this.deleteDialog = true
    },
    closeAccout () {
      selfDestruct().then(res => {
        this.$message.success(this.$t('closeAccountSuccess'))
        config.clearUserData()
        setTimeout(() => {
          this.$router.push('/')
        }, 2000)
      })
    },
    languageChange (value) {
      this.userCopy.language = value
    },
    handleApply () {
      const obj = {
        userId: Cookies.get(config.userId),
        bGrant: this.isApply ? 1 : 0
      }
      grantPermission(obj).then(res => {
        if (res.code === 1) {
          this.$message.success(this.$t('Successful'))
          this.getTime()
        }
      })
    },
    getTime () {
      getUserInfo().then(res => {
        this.time = res.data.grantPermission ? res.data.grantPermission : ''
        this.isApply = res.data.grantState
      })
    }
  }
}
</script>

<style lang="less" scoped>
.userinfo-main {
  .info-item {
    margin-top: 10px;
    min-height: 54px;
    padding: 10px 0;
    border-bottom: 1px solid #CCDEEE;
    display: inline-block;
    vertical-align: top;
    width: calc(50% - 50px);
    &:nth-child(odd) {
      margin-right: 50px;
    }
    &:nth-child(even) {
      margin-left: 50px;
    }
    .info-item-label {
      font-size: 16px;
    }
    .info-item-content {
      margin-top: 10px;
      height: 22px;;
    }
  }
  .user-title {
    font-size: 16px;
    margin: 20px 0 10px;
    .span_time{
      float: right;
      font-size: 13px;
      color: #098DFF;
    }
  }
  .edit-section {
    text-align: right;
    height: 20px;
    overflow: hidden;
    position: absolute;
    right: 20px;
    i {
      cursor: pointer;
    }
  }
}
.contentLast{
  margin-top: 10px;
}
</style>
